import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import OkoiyaWrapped from '../dashboard/memories/OkoiyaWrapped';

/**
 * Public Wrapped — the link couples share to WhatsApp / Instagram.
 * Route (add in App.jsx, public, no auth):
 *   { path: '/wrapped/:weddingSlug', element: <WrappedPage /> }
 *
 * Uses get_wrapped_public_data: financial figures are never exposed here.
 * Only resolves for premium weddings whose date has passed.
 */
export default function WrappedPage() {
  const { weddingSlug } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [state, setState] = useState('loading'); // loading | ready | missing

  useEffect(() => {
    let alive = true;
    (async () => {
      const { data: d, error } = await supabase.rpc('get_wrapped_public_data', {
        p_slug: weddingSlug,
      });
      if (!alive) return;
      if (error || !d) setState('missing');
      else { setData(d); setState('ready'); }
    })();
    return () => { alive = false; };
  }, [weddingSlug]);

  if (state === 'loading') {
    return (
      <div style={screenStyle}>
        <a href="https://okoiya.com" style={{ fontFamily: 'Gibs, serif', fontSize: 28, color: '#fff', textDecoration: 'none' }}>Okoiya</a>
        <div style={{ fontFamily: 'Nunito Sans, sans-serif', fontSize: 14, color: 'rgba(255,255,255,0.6)', marginTop: 12 }}>
          Setting the scene…
        </div>
      </div>
    );
  }

  if (state === 'missing') {
    return (
      <div style={screenStyle}>
        <div style={{ fontFamily: 'Gibs, serif', fontSize: 26, color: '#fff' }}>
          This story isn't ready yet
        </div>
        <div style={{ fontFamily: 'Nunito Sans, sans-serif', fontSize: 14, color: 'rgba(255,255,255,0.6)', marginTop: 12, maxWidth: 340, lineHeight: 1.6 }}>
          The Wrapped you're looking for hasn't been published, or the link isn't quite right.
        </div>
        <button
          onClick={() => navigate('/')}
          style={{
            marginTop: 28, background: '#C4826A', color: '#fff', border: 'none',
            borderRadius: 10, padding: '12px 24px', cursor: 'pointer',
            fontFamily: 'Nunito Sans, sans-serif', fontSize: 14, fontWeight: 700,
          }}
        >
          Plan your own wedding with Okoiya
        </button>
      </div>
    );
  }

  return (
    <OkoiyaWrapped
      data={data}
      onClose={() => navigate(data?.wedding?.slug ? `/w/${data.wedding.slug}` : '/')}
    />
  );
}

const screenStyle = {
  position: 'fixed', inset: 0, background: '#1A1A1A',
  display: 'flex', flexDirection: 'column', alignItems: 'center',
  justifyContent: 'center', textAlign: 'center', padding: 24,
};
